import React from 'react'
import SelectedLink from 'lib/components/selected-link'
import EasingBar from 'lib/components/charts/shapes/easing-bar'

class SBIEasingBar extends React.PureComponent {
  render() {
    const { category, id, label } = this.props

    return (
      <SelectedLink
        category={category}
        selected={id}
        track={label}
        trackAs="chart-item"
        avoidHref={true}
      >
        <EasingBar {...this.props} />
      </SelectedLink>
    )
  }
}

export default SBIEasingBar



// WEBPACK FOOTER //
// ./src/components/charts/shapes/easing-bar.js